import React from "react";
import styled from "styled-components";
const UserDetails = ({ userDetail }) => {
  const { user_name, birthdate, address, mobile, standard } = userDetail;
  return (
    <AddUserWrapper>
      <div>
        <div>
          <h5 className="title">Name </h5>
          <p>{user_name}</p>
        </div>
        {birthdate && (
          <div>
            <h5 className="title">Birthdate </h5>
            <p>{birthdate}</p>
          </div>
        )}
        {standard && (
          <div>
            <h5 className="title">Standard </h5>
            <p>{standard}</p>
          </div>
        )}
        {address && (
          <div>
            <h5 className="title">Address </h5>
            <p>{address}</p>
          </div>
        )}
        {mobile && (
          <div>
            <h5 className="title">Phone Number </h5>
            <p>{mobile}</p>
          </div>
        )}
      </div>
    </AddUserWrapper>
  );
};

export default UserDetails;

const AddUserWrapper = styled.div`
  .title {
    font-weight: bold;
  }
`;
